import { TertiaryButton } from "@coherehealth/common";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  unassignButton: {
    padding: theme.spacing(1, 2),
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
}));

const UnassignButton = (props: React.ComponentProps<typeof TertiaryButton>) => {
  const classes = useStyles();

  return <TertiaryButton className={classes.unassignButton} {...props} />;
};

export default UnassignButton;
